var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPlanogram = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32.001,
    viewBox: "0 0 32 32.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,32H5.016a5,5,0,0,1-5-5V5a5.01,5.01,0,0,1,5-5h22a5,5,0,0,1,5,5v9a1,1,0,0,1-2,0V5a3,3,0,0,0-3-3h-22a3.007,3.007,0,0,0-3,3V27a3,3,0,0,0,3,3H9a1,1,0,0,1,0,2Z",
    transform: "translate(-1.018 -1)",
    fill: "current"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    rx: 2,
    transform: "translate(2.982 4)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    rx: 2,
    transform: "translate(11.982 4)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    rx: 2,
    transform: "translate(20.982 4)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    rx: 2,
    transform: "translate(2.982 10)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    rx: 2,
    transform: "translate(2.982 16)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    rx: 2,
    transform: "translate(11.982 10)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    rx: 2,
    transform: "translate(20.982 10)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,32a1,1,0,0,1-.707-1.707l5-5a1,1,0,0,1,1.539.152l1.286,1.929,8.139-9.044a1,1,0,0,1,1.487,1.338l-9,10a1,1,0,0,1-1.575-.114l-1.323-1.985-4.137,4.137A1,1,0,0,1,14,32Z",
    transform: "translate(-1.018 -1)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,27a1,1,0,0,1-1-1V20.011A1.036,1.036,0,0,0,28.989,19H23a1,1,0,0,1,0-2h6.019A3.03,3.03,0,0,1,32,19.981q0,.01,0,.019v6A1,1,0,0,1,31,27Z",
    transform: "translate(-1.018 -1)",
    fill: "current"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlanogram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Planogram.fb9085c9.svg";
export { ForwardRef as ReactComponent };